import { getRequest, postRequest, putRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getCustodiansRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.custodians.getCustodians, {
      ApplicationUid,
    }),
  );

export const createCustodianRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.custodians.custodian, {
      ApplicationUid,
    }),
    data,
  );

export const updateCustodianRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.custodians.custodian, {
      ApplicationUid,
    }),
    data,
  );
